document.addEventListener("DOMContentLoaded", function () {
	var swiper = new Swiper(".sls-container", {
		loop: true,
		autoplay: false,
		allowTouchMove: true,
		grabCursor: true,
		// breakpoints: {
		// 	1024: {
		// 		enabled: false,
		// 	},
		// 	1023: {
		// 		enabled: true,
		// 	},
		// },
	});
});
